/**
 * @Author:
 * @Description:
 * @DateTime: Created in 14:29 2020/3/12
 */

/**
 * 表示重写 方便阅读 暂无其他作用
 * @param target
 * @param key
 * @param descriptor
 * @returns {any}
 */
export default function override (target, key, descriptor) {
	return descriptor
}
